import { ImageUrlPipe } from './imageUrl';
import { FormatTimeAgoPipe } from './formatTimeAgo';
import { FormatTimePipe } from './formatTime';
import { BgImagePipe } from './bgImage';
import { FormatMessageDatePipe } from './formatMessageDate';
import { FormatDatePipe } from './formatDate';
import { FirstErrorPipe } from './firstError';
import { SafePipe } from './safe';
import { ApiPipe } from './api';
import { RejectionReasonPipe } from './rejectionReason';
import { LocalizedDatePipe } from './localized-date.pipe';
import { MoneyPipe } from './money.pipe';
import { RelativeDateTimePipe } from './relativeDateTime';

export const pipes: any[] = [
    ImageUrlPipe,
    BgImagePipe,
    FormatTimeAgoPipe,
    FormatTimePipe,
    FormatDatePipe,
    FormatMessageDatePipe,
    FirstErrorPipe,
    SafePipe,
    ApiPipe,
    RejectionReasonPipe,
    LocalizedDatePipe,
    MoneyPipe,
    RelativeDateTimePipe,
];

export const pipeServices: any[] = [
    ImageUrlPipe
];
